import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { CalcConfigService } from '_services/calc-config.service';
import { Population } from '../../_models/population';
import { HelpComponent } from '../../_shared/help/help.component';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { AidYearComponent } from '../../_shared/aid-year/aid-year.component';
import { MatCard } from '@angular/material/card';
import { AsyncPipe } from '@angular/common';
import { UsageComponent } from '../usage/usage.component';
import { KeyboardScrollableDirective } from '../../_shared/directives/keyboard-scrollable.directive';

@Component({
    selector: 'app-populations',
    templateUrl: './populations.component.html',
    styleUrls: ['./populations.component.css'],
    imports: [HelpComponent, MatButton, MatIcon, AidYearComponent, MatCard, UsageComponent, AsyncPipe, KeyboardScrollableDirective]
})
export class PopulationsComponent {
  constructor(
    private titleService: Title,
    private route: ActivatedRoute,
    private router: Router,
    public cc: CalcConfigService
  ) {
    this.titleService.setTitle('Populations' + ' | NPC Admin');
  }

  createPopulation(): void {
    this.router.navigate(['new'], { relativeTo: this.route });
  }

  openPopulation(population: Population): void {
    this.router.navigate([population.id], { relativeTo: this.route });
  }

  activatePopulation(event: Event, population: Population): void {
    event.preventDefault();
    event.stopPropagation();
    this.openPopulation(population);
  }

  trackByPopulationId(_index: number, population: Population): string {
    return population.id;
  }
}
